import { style } from 'typestyle'
export const pt12 = style({ paddingTop: '12px' })
